import { render, staticRenderFns } from "./CopyButton.vue?vue&type=template&id=3a521528&scoped=true"
import script from "./CopyButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopyButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CopyButton.vue?vue&type=style&index=0&id=3a521528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a521528",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CIcon: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CIcon/CIcon.vue').default,CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default,CTooltip: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CTooltip/CTooltip.vue').default})
